module.exports = __webpack_public_path__ + "img/rightTwo-img.368e8f1d.png";